/**
 * Archivo Js que permite definir, administrar, controlar y configurar las rutas del modulo 
 * de la aplicacion, se integra facilmente con la instancia de Vue, facilita
 * la creacion y el mantenimiento de las peticiones en el proyecto
 */

/**Definicion de componentes o librerias necesarioas que se complementan con el router*/
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Administrar from '@/router/administrar/Administrar'
import Prestadores from '@/router/prestadores/Prestadores'
import Contrato from '@/router/contrato/Contrato'
import Muestras from '@/router/muestras/Muestras'
import PruebaGratuita from '@/router/muestras/pruebaGratuita/PruebaGratuita'

/**Inyectamos el componente router de vuejs */
Vue.use(Router)

/**
 * Instanciamos el router y lo integramos como la instancia principal de vuejs
 */
const router = new Router({

  /**Atributo que permite definir el modo history del router, no hace uso de # en las peticiones */
  mode: 'history',

  base: '/famisoft/',

  /**Objeto que define las rutas de la aplicacion */
  routes: [
    {

      /**Ruta principal de la aplicacion */
      path: '/',

      /**Atributo que define los metaddatos de la ruta principal */
      meta: {

        /**Atributo que define si la ruta requiere autenticacion */
        requiresAuth: true
      },

      /**Atributo que permite redireccionar a la vista home */
      redirect: {

        /**Atributo que define el nombre de la vista */
        name: 'loginPortal'
      }
    },
    {
      /**Atributo que defini la ruta home */
      path: '/home',

      /**Atributo que define el nombre de la ruta home */
      name: 'home',

      /**Atributo que permite cargar la vista home */
      component: Home,

      /**Atributo que define los metadatos de la ruta home */
      meta: {

        /**Atributo que define si la ruta requiere autenticacion */
        requiresAuth: true
      }
    },
    {

      /**Atributo que define la ruta para iniciar sesion */
      path: '/login',

      /**Atributo que define el nombre para iniciar sesion */
      name: 'login',

      /**Atributo que define los metadatos de la aplicacion */
      meta: {

        /**Atributo que define el diseño de presentacion del contenido */
        layout: 'blank'
      },

      /**Atributo que permite cargar la vista para iniciar sesion */
      component: () => import('@/views/session/Login.vue')
    },
    {
      /** Atributo que permite definir la ruta de inicio de sesion para el prestador */
      path: '/login_prestador',
      /** Atributo que define el nombre para iniciar sesion */
      name: 'login_prestador',
      /** Atributo que define los metadatos de la aplicacion */
      meta: {
        /**Atributo que define el diseño de presentacion del contenido */
        layout: 'blank'
      },
      /** Atributo que permite cargar la vista para iniciar sesion */
      component: () => import('@/views/session/LoginPrestador.vue')
    },
    {
      /** Atributo que permite definir la ruta de inicio de sesion para el prestador */
      path: '/login_portal',
      /** Atributo que define el nombre para iniciar sesion */
      name: 'loginPortal',
      /** Atributo que define los metadatos de la aplicacion */
      meta: {
        /**Atributo que define el diseño de presentacion del contenido */
        layout: 'blank'
      },
      /** Atributo que permite cargar la vista para iniciar sesion */
      component: () => import('@/views/session/LoginPortal.vue')
    },
    {
      /**Atributo que permite definir todas las vistas que no hacen parte de la aplicacion */
      path: '*',

      /**Atributo que permite definir los metadatos de las peticiones que no hacen parte de la aplicacion */
      meta: {

        /**Atributo que permite definir el diseño de presentacion de la aplicacion */
        layout: 'blank'
      },

      /**Atributo que permite definir la vista de presentacion cuando la ruta no exite 404 */
      component: () => import('@/views/NotFound.vue')
    },

    /**Inyectamos el router del modulo Administrar */
    ...Administrar,
    /** Inyectamos el router del modulo de Prestadores */
    ...Prestadores,
    /**Inyectamos el router del modulo Contratos de salud */
    ...Contrato,
    /** Inyectamos el router para visualizar los resultados de muestras para prestadores */
    ...Muestras,
    ...PruebaGratuita
  ]
});

/**Metodo que se dispara cada vez que se realiza una peticion, verifica que el usuario este autenticado */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem("USER_TOKEN")) {
    return next({
      name: 'loginPortal'
    });
  } else {
    next();
  }
})

/**Exportamos el modulo para inyectar en la instancia principal de Vue */
export default router